import jwtDecode from 'jwt-decode';

export default (jwtString) => {
  const data = jwtDecode(jwtString);

  if (!data instanceof Object) {
    throw new Error(`JWT token value is invalid.`);
  }

  return Object.keys(data)
    .reduce((preparedData, field) => {
      let fieldParts = field.split('/');
      let value = isJsonString(data[field])
        ? JSON.parse(data[field])
        : data[field];
        
      field = fieldParts[fieldParts.length - 1];
      preparedData[field] = value;

      return preparedData;
    }, {});
};

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/tools/jwt-decode.js